import {
  Box,
  HStack,
  IconButton,
  Progress, Slider, SliderFilledTrack, SliderThumb,
  SliderTrack, Text
} from "@chakra-ui/react";
import React, {ForwardedRef, forwardRef, MutableRefObject, useImperativeHandle, useRef, useState} from "react";
import {IoMic,IoPause,IoPlay, IoRadioButtonOn, IoStopCircle,IoVolumeMedium } from "react-icons/io5";
import { useAudioRecorder } from "react-use-audio-recorder";

import {useTheme} from "../hooks/ThemeProvider";
import {formatTime} from "../Utils";
import AudioPlayer, {AudioPlayerUpdate} from "./AudioPlayer";
import Markdown from "./Markdown";
import TimerComponent, {TimerComponentStop} from "./TimerComponent";

export type AudioRecorderStart = {
  startRecording: () => void;
}

type RecorderProps = {
  responseTime?: number;
  audioSourceUrl? : string;

  disabled?: boolean;

  //setRecordedAudio? : React.Dispatch<React.SetStateAction<Blob | undefined>>;

  onRecordingEnded?: (isSilent: boolean, blob: Blob) => void;

  demo?: boolean
};

const AudioRecorder = forwardRef((props: RecorderProps, ref: ForwardedRef<AudioRecorderStart>) => {
  const theme = useTheme().theme;
  const audioPlayerRef = useRef<AudioPlayerUpdate>(null);
  let timerInterval = 0;
  const responseTime = props.responseTime!== undefined ? props.responseTime : 10;
  // 10 seconds, without defined props.responseTime, for demo
  const timeLeft = useRef<number>(responseTime);
  const timerComponentRef = useRef<TimerComponentStop>(null);

  const {
    recordingStatus,
    recordingTime,
    startRecording,
    stopRecording,
    pauseRecording,
    resumeRecording,
    getBlob,
    saveRecording,
  } = useAudioRecorder();

  const handleStartRecording = async () => {
    timeLeft.current=responseTime;
    await startRecording();
    if (timerComponentRef.current) timerComponentRef.current.startTimer();
    //console.log(started)
/*
    if (timerInterval !== 0) window.clearInterval(timerInterval);
    timerInterval = (window.setInterval(() => {
      stopRecording((blob) => {
        handleStopRecording(blob);
      });
    }, (recordingTime) * 1000)); // seconds to milliseconds, 1000));

*/
  };

  useImperativeHandle(ref, () => ({
    startRecording() {
      handleStartRecording();
    }
  }));

  const handleStopRecording = async (blob: Blob | undefined) => {
    //window.clearInterval(timerInterval);

    if (timerComponentRef.current) timerComponentRef.current.stopTimer();

    if (blob) {
      const isSilent = await checkIsSilent(blob);

      /*

       if silent, save correct false to DB

      if (!isSilent) {
        if (props.setRecordedAudio) {
          props.setRecordedAudio(blob);
        }
        if (props.demo && audioPlayerRef.current) {
          audioPlayerRef.current.updateSource(URL.createObjectURL(blob));
        }

      } else {
        if (props.setRecordedAudio) {
          props.setRecordedAudio(undefined);
        }
      }

      if (props.setRecordedAudio) {
        props.setRecordedAudio(blob);
      }
       */
      if (props.demo && audioPlayerRef.current) {
        audioPlayerRef.current.updateSource(URL.createObjectURL(blob));
      }

        if (props.onRecordingEnded)
          props.onRecordingEnded(isSilent, blob );
    }
  }

  const checkIsSilent = async (blob: Blob) => {
    const arrayBuffer = await blob.arrayBuffer();
    const audioCtx = new AudioContext();
    const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);

    // Get raw PCM data
    const data = audioBuffer.getChannelData(0);
    let sum = 0;

    for (let i = 0; i < data.length; i++) {
      sum += data[i] * data[i];
    }

    const rms = Math.sqrt(sum / data.length);
    const silenceThreshold = 0.01;

    return rms < silenceThreshold;
  };

  const canRecord = () =>{
    return (!recordingStatus || recordingStatus === "stopped");
  }

  return (
    <Box
        marginTop="2"
        marginBottom="2"
        padding="2"
        borderWidth="1px"
        borderRadius="lg"
        borderColor={theme.OUTLINE}
        borderStyle="solid"
        width="min-content"
        minWidth="xs"
        >
      <HStack
        marginBottom={2}>
        <IconButton
          aria-label="Record Audio"
          size="lg"

          icon={ canRecord() ? <IoMic size={"2em"} /> : <IoStopCircle size={"2em"} />   }
          colorScheme={theme.COLOR_SCHEME}

          disabled={ recordingStatus !== "recording" && ( !canRecord() || props.disabled===true )}

          onClick={() => {
            if (canRecord()) {
              //if (audioPlayerRef.current) audioPlayerRef.current.updateSource("");
              handleStartRecording();
            } else {
               stopRecording((blob) => {
                 handleStopRecording(blob);
               });
            }
          }}
        />
        <TimerComponent timeLeft={timeLeft}  ref={timerComponentRef}
                      onTimerFinished={(timeLeft: number) => {
                          stopRecording((blob) => {
                                  handleStopRecording(blob);
                                });
                        }
                      }
                    startOnChange={false}
                    displayText=""
                />
        {/* <Markdown
          content={formatTime(recordingTime)}
        /> */}
        <Text width="max-content"><b>Response Time:</b> {responseTime} seconds</Text>
        {recordingStatus === "recording" &&
            <IoRadioButtonOn  size="1.5em" color="red"/>
        }
      </HStack>

      {props.demo &&
                <AudioPlayer ref={audioPlayerRef}
                    sourceUrl={""}
                    noOutline={true}
                    maxNumberOfReproductions={0}
                />
      }
    </Box>
  );
});

export default AudioRecorder;
